import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Breakpoints } from '@rd-lib/breakpoints';
import { UrlUtilsService } from '@rd/core/services/url-utils/url-utils.service';
import { WindowResizeService } from '@rd/core/services/window-resize/window-resize.service';
import { LoyaltyCurrency } from '@rd/types';
import * as CSS from 'csstype';
import { Subscription } from 'rxjs';

@Component({
  selector: 'rd-tcv2-programs-banner',
  templateUrl: './programs-banner.component.html',
  styleUrls: ['./programs-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TcV2ProgramsBannerComponent implements OnInit, OnDestroy {
  @HostBinding('class.rd-tcv2-programs-banner') componentClass = true;

  @Input() loyaltyCurrencySelected: LoyaltyCurrency;

  resizeSubscription$: Subscription;
  isMobileViewport: boolean;

  constructor(
    protected cdRef: ChangeDetectorRef,
    protected urlUtilsService: UrlUtilsService,
    protected windowResizeService: WindowResizeService,
  ) {}

  ngOnInit(): void {
    this.detectViewportSize();
    this.setupSubscriptions();
  }

  ngOnDestroy(): void {
    if (this.resizeSubscription$) {
      this.resizeSubscription$.unsubscribe();
    }
  }

  backgroundImageStyle(): CSS.Properties {
    if (this.isMobileViewport) {
      return {
        backgroundImage: `url(${this.urlUtilsService.imageUrl(
          '/images/TC_ProductMasterHead_Mobile.jpg',
        )})`,
      };
    } else {
      return {
        backgroundImage: `url(${this.urlUtilsService.imageUrl(
          '/images/TC_ProductMasterHead_Desktop.jpg',
        )})`,
      };
    }
  }

  bannerTitleTranslationParams(): { loyaltyCurrency: string } {
    return { loyaltyCurrency: this.loyaltyCurrencySelected.shortName };
  }

  private setupSubscriptions(): void {
    this.resizeSubscription$ =
      this.windowResizeService.windowResizeObservable.subscribe(() => {
        this.detectViewportSize();
      });
  }

  private detectViewportSize(): void {
    this.isMobileViewport = window.innerWidth < Breakpoints.TABLET;
    this.cdRef.detectChanges();
  }
}
